// eslint-disable-next-line no-restricted-syntax, unused-imports/no-unused-vars
const enum ShortcutStateEnum {
  Empty = 0,
  GenerationFailed = 1,
  Generating = 2,
  Deleted = 3,
  Ok = 4,
}

// eslint-disable-next-line no-restricted-syntax
export const enum GenerationType {
  Legacy = 0,
  BundleGen = 1,
  SinglePage = 2,
}

export type ShortcutStateName = keyof typeof ShortcutStateEnum;
export type ShortcutStateNames = { readonly [P in ShortcutStateName]: P };

export const ShortcutState: ShortcutStateNames = {
  Empty: "Empty",
  GenerationFailed: "GenerationFailed",
  Generating: "Generating",
  Deleted: "Deleted",
  Ok: "Ok",
};

// eslint-disable-next-line no-restricted-syntax, unused-imports/no-unused-vars
const enum MentionSourceTypeEnum {
  Issue = 0,
  IssueComment = 1,
  PublishNote = 2,
  DiskoDocumentNode = 3,
  DiskoDiagramObject = 4,
}

export type MentionTypeName = keyof typeof MentionSourceTypeEnum;
export type MentionTypeNames = { readonly [P in MentionTypeName]: P };

export const MentionType: MentionTypeNames = {
  Issue: "Issue",
  IssueComment: "IssueComment",
  PublishNote: "PublishNote",
  DiskoDocumentNode: "DiskoDocumentNode",
  DiskoDiagramObject: "DiskoDiagramObject",
};
